module.exports = __webpack_public_path__ + "static/media/left-caret-blue.a8874d90.svg";